import React from "react";
import "./Dialog.scss";

const Dialog = ({
  isOpen,
  title,
  message,
  onConfirm,
  onCancel,
  type = "info",
}) => {
  if (!isOpen) return null;

  return (
    <div className="dialog-overlay">
      <div className="dialog-content">
        <div className={`dialog-header ${type}`}>
          <h3>{title}</h3>
        </div>
        <div className="dialog-body">
          <p>{message}</p>
        </div>
        <div className="dialog-actions">
          <button className="confirm-btn" onClick={onConfirm}>
            {type === "confirm" ? "Yes" : "OK"}
          </button>
          {type === "confirm" && (
            <button className="cancel-btn" onClick={onCancel}>
              No
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Dialog;
